App.factory('monthsService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function MonthsService() {
        this.dataMonthsList = function() {
            return baseService.getWithOutAuth('Scripts/Json/months.json').then(function(success) {
                return success;
            }, function(error) {
                // console.log(error);
            });
        };
        
    }
    return new MonthsService();
}]);